import { ReactComponent as InfoIcon } from '~/assets/images/iconsLibrary/info.svg';

import IconHoc from './IconHoc';

export default IconHoc(InfoIcon);
